/**
 * Typy endpointů (controllerů) na webové službě TEAF
 * @includeToDoc
 */
export enum ASServices {
    /**
    * odkaz na obecne metody pracujici s OWManagerem
    */
    owManager,
    /**
    * odkaz na metody nepotrebujici autentizaci
    */
    descriptions,
    /**
    * odkaz na metody pracujici s lokalizacemi
    */
    cultures,
    /**
    * odkaz na metody pracujici s radky
    */
    dataRows,
    /**
    * odkaz na metody pracujici s instanci aplikacni tridy
    */
    instances,
    /**
    * odkaz na metody poskytujici operace spojene s kryptografii
    */
    cryptography,
    /**
    * odkaz na metody poskytujici operace spojene s DMS
    */
    dms,
    /**
     * odkaz na endpoint pro práci s menu
     */
    menu,
    /**
     * nový datareader
     */
    data,
    /**
     * odkaz na metody pracujici s upravou kontextem
     */
    context,
    /**
     * odkaz na metody pracujici s exportem/importem
     */
    exportImport,
}

const asAPIv01 = "api/v01/as";
const asAPIv02 = "api/v02/as";
const asServicesUrls = [
    `${asAPIv01}/owmanager`,
    `${asAPIv01}/descriptions`,
    `${asAPIv01}/culture`,
    `${asAPIv01}/datarows`,
    `${asAPIv01}/instance`,
    `${asAPIv01}/cryptography`,
    `${asAPIv01}/dms`,
    `${asAPIv02}/menu`,
    `${asAPIv02}/data`,
    `${asAPIv02}/context`,
    `${asAPIv02}/exportimport`,
]; //`

export function getServiceURL(service: ASServices) {
    return asServicesUrls[service];
}
